var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5TransitionFail = function SvgAv5TransitionFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E34646",
    "data-no-fill": "true",
    "data-no-stroke": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 8H4.597",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    "data-no-fill": "true",
    "data-no-stroke": "true"
  })));
};
export { SvgAv5TransitionFail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iI0UzNDY0NiIgZGF0YS1uby1maWxsPSJ0cnVlIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPHBhdGggZD0iTTExLjIwMDIgOEw0LjU5NzQyIDgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgo8L3N2Zz4K";